import { CommonModule } from '@angular/common';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, Optional, SkipSelf } from '@angular/core';
import { AdminAuthGuard } from './guards/admin-auth-guard.service';
import { AuthGuard } from './guards/auth-guard.service';
import { StaffAuthGuard } from './guards/staff-auth-guard.service';
import { CredentialsInterceptor } from './interceptors/credentials.interceptor';
import { HttpResponseErrorInterceptor } from './interceptors/http-response-error.interceptor';
import { ImpersonationInterceptor } from './interceptors/impersontation.interceptor';
import { UserAuthorizationService } from './services/user-authorization.service';
import { LoginComponent } from './components/login/login.component';

@NgModule({
    imports: [
        CommonModule
    ],
    providers: [
        UserAuthorizationService,
        AuthGuard,
        AdminAuthGuard,
        StaffAuthGuard,
        { provide: HTTP_INTERCEPTORS, useClass: CredentialsInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: HttpResponseErrorInterceptor, multi: true },
        { provide: HTTP_INTERCEPTORS, useClass: ImpersonationInterceptor, multi: true },
    ],
    declarations: [
        LoginComponent,
    ],
})
export class SecurityModule {

    constructor(@Optional() @SkipSelf() parentModule: SecurityModule) {
        if (parentModule) {
            throw new Error(
                'SecurityModule is already loaded. Import it in the AppModule only');
        }
    }

}
